import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { routerActions, push } from "connected-react-router";
import { string, func, node, bool, number, shape } from "prop-types";
import classNames from "classnames";

import { selectors as sessionSelectors } from "reducers/session";
import { selectors as communicationsSelectos } from "reducers/communications";
import { actions as depositsActions } from "reducers/deposits";

import EditableLabel from "pages/_components/fields/EditableLabel";
import { resizableRoute } from "pages/_components/Resizable";
import I18n from "pages/_components/I18n";
import Menu from "pages/_components/menu/Menu";
import Image from "pages/_components/Image";
import Header from "pages/_components/header/Header";
import Badge from "pages/_components/Badge";
import Button from "pages/_components/Button";
import { Helmet } from "react-helmet";
import * as utilsI18n from "util/i18n";
import Back from "pages/_components/CustomProductHead/_components/Back";

import { selectors as assistantSelectors } from "reducers/assistant";
import { actions as productsActions } from "reducers/products";

import CustomButton from "pages/_components/CustomButton/CustomButton";
import { isIOS } from "react-device-detect";

class DepositsHead extends Component {
    static propTypes = {
        className: string,
        // i18n head title
        title: node,
        // specify a translated text instead a i18n key
        titleText: string,
        // specify a translated text instead a i18n key
        depositNumber: string,
        // back link url
        backLinkTo: string,
        // back function, ignored if backLinkTo is specified
        onBack: func,
        // close link url
        closeLinkTo: string,
        // onClose function link, ignored if closeLinkTo is specified
        onClose: func,
        // link url, it links located under title
        // linkTo: string,
        // I18n id of link text, it is located under title
        // head logo
        logo: node,
        // called right after button with closeLinkTo is clicked
        onCloseClick: func,
        hasCenterContent: bool,
        showPlusIcon: bool,
        accessibilityTextId: string,
        dispatch: func.isRequired,
        idDeposit: string.isRequired,
        hasActiveSession: bool,
        isMobile: bool,
        isDesktop: bool,
        unreadCommunications: number,
        onAdd: func,
        addLinkTo: string,
        addLinkToLabel: string,
        exportList: string,
        handleInviteClick: func.isRequired,
        // environments: string,
        activeEnvironment: string,
        note: string,
        handleClick: func.isRequired,
        // isFetchingExport: bool,
        children: shape().isRequired,
        replace: string,
        hideNavbarInMobile: bool,
        updateFocus: bool, // Prop which defines if component will re render if updated or not
        autoLabelFlag: bool,
        editable: string,
        addButtonDisabled: bool,
    };

    static defaultProps = {
        className: "",
        title: null,
        titleText: "",
        depositNumber: "",
        backLinkTo: "",
        onBack: null,
        closeLinkTo: "",
        onClose: null,
        logo: null,
        onCloseClick: () => {},
        hasCenterContent: false,
        showPlusIcon: false,
        accessibilityTextId: "",
        hasActiveSession: false,
        isMobile: false,
        isDesktop: false,
        unreadCommunications: 0,
        onAdd: null,
        addLinkTo: "",
        addLinkToLabel: "",
        exportList: "",
        // environments: "",
        activeEnvironment: "",
        note: "",
        // isFetchingExport: false,
        replace: "",
        hideNavbarInMobile: false,
        updateFocus: true,
        autoLabelFlag: false,
        editable: null,
        addButtonDisabled: false,
    };

    constructor(props) {
        super(props);
        this.titleRef = React.createRef();
    }

    componentDidMount() {
        if (this.titleRef.current) {
            this.titleRef.current.focus({
                preventScroll: true,
            });
        }
    }

    componentDidUpdate() {
        const { updateFocus } = this.props;
        if (this.titleRef.current && updateFocus) {
            this.titleRef.current.focus({
                preventScroll: true,
            });
        }
    }

    handleOptionsClick = () => {
        const { dispatch, depositNumber } = this.props;
        dispatch(depositsActions.toggleOptions([depositNumber, "DOWNLOAD"]));
    };

    getLeftOption = () => {
        const {
            backLinkTo,
            onBack,
            closeLinkTo,
            onClose,
            hasActiveSession,
            isMobile,
            unreadCommunications,
        } = this.props;
        if (backLinkTo || onBack) {
            return backLinkTo ? <Back backLinkTo={backLinkTo} /> : <Back onBack={onBack} />;
        }
        if (hasActiveSession && isMobile && !closeLinkTo && !onClose) {
            return (
                <div className="toolbar-item notification">
                    <Link className="btn toolbar-btn" to="/communications">
                        <Image className="svg-icon svg-caret" src="images/email.svg" />
                        <I18n id="menu.chat" />
                        {unreadCommunications > 0 && (
                            <>
                                <Badge count={unreadCommunications} />
                                <I18n id="menu.chat.badge" componentProps={{ className: "visually-hidden" }} />
                            </>
                        )}
                    </Link>
                </div>
            );
        }

        return null;
    };

    close = () => {
        const { onCloseClick, dispatch, closeLinkTo } = this.props;
        onCloseClick();
        dispatch(routerActions.replace({ pathname: closeLinkTo, state: { transition: "transition-flow-close" } }));
    };

    add = () => {
        const { dispatch, onAdd, addLinkTo, isDesktop } = this.props;

        if (onAdd) {
            onAdd();
        }
        let routerAction = {
            pathname: addLinkTo,
            state: { transition: "transition-flow-open" },
        };

        if (isDesktop) {
            // con la transition no está funcionando en Desktop, se quita y se sigue el issue para encontrar el motivo
            routerAction = {
                pathname: addLinkTo,
            };
        }

        dispatch(routerActions.replace(routerAction));
    };

    goToPage = (page) => {
        const { dispatch } = this.props;
        dispatch(push(page));
    };

    getRightOption = () => {
        const {
            addLinkTo,
            addLinkToLabel,
            closeLinkTo,
            exportList,
            handleInviteClick,
            hasActiveSession,
            isDesktop,
            isMobile,
            onAdd,
            onClose,
            showPlusIcon,
            // environments,
            // activeEnvironment,
            note,
            hideNavbarInMobile,
            addButtonDisabled,
            handleClick,
            dispatch,
            idDeposit,
        } = this.props;

        const noteElement = (
            <div className="toolbar-item view-note">
                <span>{note}</span>
            </div>
        );

        const closeElement = (
            <div className="toolbar-item">
                <Button
                    className="toolbar-btn view-close"
                    onClick={closeLinkTo ? this.close : onClose}
                    image="images/figma/icon/cross.svg"
                    label="global.close"
                    bsStyle="link"
                />
            </div>
        );

        if (closeLinkTo || onClose || note) {
            return (
                <>
                    {note && noteElement}
                    {(closeLinkTo || onClose) && closeElement}
                </>
            );
        }

        let buttons = [];
        let optionsButtons = [];

        if (exportList) {
            buttons = [
                ...buttons,
                <div
                    className={`toolbar-item ${addButtonDisabled ? "cancel-renovation" : "download"}`}
                    key="exportList">
                    <CustomButton
                        className="btn-outline"
                        func={() => handleClick("pdf")}
                        type="submit"
                        icon="images/figma/icon/download.svg"
                        text="global.download"
                        textType="I18N"
                    />
                </div>,
            ];
            optionsButtons = [
                ...optionsButtons,
                {
                    text: "global.download",
                    textType: "I18N",
                    icon: "images/figma/icon/download.svg",
                    func: () => handleClick("pdf"),
                },
            ];
        }

        const addButton = (
            <>
                {!addButtonDisabled && (
                    <div className="toolbar-item cancel-renovation" key="add">
                        <Button
                            onClick={this.add}
                            className={classNames({ "btn-outline": isDesktop, "toolbar-btn view-close": !isDesktop })}
                            disabled={addButtonDisabled}>
                            <I18n id={addLinkToLabel} componentProps={!isDesktop && { className: "visually-hidden" }} />
                        </Button>
                    </div>
                )}
            </>
        );

        if (addLinkTo || onAdd) {
            if (showPlusIcon) {
                return addButton;
            }
            buttons = [...buttons, addButton];
            optionsButtons = [
                {
                    text: addLinkToLabel,
                    textType: "I18N",
                    icon: "images/figma/icon/download.svg",
                    func: () => dispatch(push(`/deposits/${idDeposit}/cancelRenewal`)),
                    disabled: addButtonDisabled,
                    className: "btn",
                },
                ...optionsButtons,
            ];
        }

        if (handleInviteClick) {
            buttons = [
                <div className="toolbar-item add-user" key="invite">
                    <Button
                        onClick={handleInviteClick}
                        className="btn btn-small btn-outline"
                        image="images/figma/icon/nuevo.svg"
                        label="administration.users.list.addUser"
                    />
                </div>,
                ...buttons,
            ];
            optionsButtons = [
                {
                    text: "administration.users.list.addUser",
                    textType: "I18N",
                    icon: "images/figma/icon/nuevo.svg",
                    func: () => handleInviteClick,
                    disabled: addButtonDisabled,
                    className: "btn btn-small btn-outline",
                },
                ...optionsButtons,
            ];
        }

        if ((hasActiveSession && isMobile && !hideNavbarInMobile && !buttons.length) || isIOS) {
            return (
                <Fragment>
                    {exportList ? (
                        <div className="toolbar-item commands-mobile">
                            <Button
                                className="toolbar-btn view-options"
                                onClick={this.handleOptionsClick}
                                image={
                                    isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"
                                }
                                label="view more options"
                                block={false}
                                bsStyle="link"
                            />
                        </div>
                    ) : (
                        <Menu isMobile={isMobile} />
                    )}
                </Fragment>
            );
        }
        return buttons.length ? (
            <Fragment>
                {isDesktop ? (
                    buttons
                ) : (
                    <>
                        {/* FIX: horrible solution to display different for active/history deposits */}
                        {buttons.length > 1 ? (
                            <CustomButton
                                pullRight
                                isMobile
                                icon={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}
                                options={optionsButtons.filter((item) => !item.disabled)}
                            />
                        ) : (
                            <div className="toolbar-item commands-mobile" key="exportList">
                                <CustomButton
                                    className="btn"
                                    onClick={() => handleClick("pdf")}
                                    icon="images/figma/icon/download.svg"
                                />
                            </div>
                        )}
                    </>
                )}
            </Fragment>
        ) : null;
    };

    getCenterContent = () => {
        const {
            children,
            logo,
            replace,
            title,
            titleText,
            hasCenterContent,
            accessibilityTextId,
            autoLabelFlag,
            depositNumber,
            isDesktop,
            editable,
        } = this.props;

        const handleSave = (alias) => {
            const { dispatch, idDeposit } = this.props;
            dispatch(productsActions.changeProductAlias(alias, idDeposit));
        };

        return (
            (title || titleText || logo || hasCenterContent || accessibilityTextId) && (
                <Fragment>
                    <Helmet>
                        <title>
                            {// eslint-disable-next-line no-nested-ternary
                            utilsI18n.get(accessibilityTextId || title) !== "*undefined*"
                                ? `BiBank - ${`${utilsI18n.get(accessibilityTextId || title)} ${replace.USER_NAME ||
                                      ""}`}`
                                : titleText !== ""
                                ? `BiBank - ${titleText}`
                                : "BiBank"}
                        </title>
                    </Helmet>
                    {isDesktop && editable ? (
                        <>
                            <h1 className="title-content">{titleText}</h1>
                            {autoLabelFlag && (
                                <div className="auto-label-flag">
                                    <span className="tag tag-success" style={{ color: "#388E3C", fontWeight: "700" }}>
                                        Auto
                                    </span>
                                </div>
                            )}
                            <EditableLabel
                                isDesktop={isDesktop}
                                onSave={handleSave}
                                value={titleText.length ? titleText : depositNumber}
                                className="min-width-max-content"
                            />
                        </>
                    ) : (
                        <h1 className="title-content">{titleText}</h1>
                    )}
                    {children}
                    {/* {this.getCenterOption()} */}
                </Fragment>
            )
        );
    };

    // getCenterOption = () => {
    //     const { linkTo, linkText } = this.props;
    //     if (linkTo) {
    //         return (
    //             <p>
    //                 <Button image="images/editPen.svg" onClick={linkTo} bsStyle="link">
    //                     <Image src="images/editPen.svg" className="svg-icon" />
    //                     <I18n id={linkText} />
    //                 </Button>
    //             </p>
    //         );
    //     }
    //     return null;
    // };

    render() {
        const {
            exportList,
            showPlusIcon,
            activeEnvironment,
            editable,
            className,
            addLinkTo,
            depositNumber,
            isDesktop,
        } = this.props;
        return (
            <Header
                className={className}
                addClassName={classNames({ exportList }, { showPlusIcon }, { activeEnvironment }, { addLinkTo })}>
                {this.getLeftOption()}

                {
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                    <div className={`view-title ${editable && "editable"}`} ref={this.titleRef}>
                        {this.getCenterContent()}
                    </div>
                }
                {this.getRightOption()}
                {isDesktop && (
                    <div className="acct-number toolbar-item">
                        <I18n id="deposits.certificate" />
                        {` ${depositNumber}`}
                    </div>
                )}
            </Header>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: assistantSelectors.isAssistantLogin(state) ? false : sessionSelectors.isLoggedIn(state),
    unreadCommunications: communicationsSelectos.getUnreadCommunications(state),
    environments: sessionSelectors.getEnvironments(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(resizableRoute(DepositsHead));
